const RE_CZECH_PHONE_NATIONAL_PREFIX = /^\+420\s*/;
const RE_WHITESPACE = /\s/g;

export const addNonBreakableSpace = (input) => input.replace(RE_WHITESPACE, '\xA0');

export const trimCzechPhoneNrPrefix = (phoneNr) =>
	phoneNr.replace(RE_CZECH_PHONE_NATIONAL_PREFIX, '');

export const quoteBackticks = (input) => `\`${input}\``;

export const isPrintableChar = (keycode, includeEnterKey) =>
	keycode === 32 ||
	(includeEnterKey && keycode === 13) || // spacebar & return key(s) (if you want to allow carriage returns)
	(keycode > 47 && keycode < 58) || // number keys
	(keycode > 64 && keycode < 91) || // letter keys
	(keycode > 95 && keycode < 112) || // numpad keys
	(keycode > 185 && keycode < 193) || // ;=,-./` (in order)
	(keycode > 218 && keycode < 223); // [\]' (in order)

export const setCharAtIndex = (value, idx, char) =>
	`${value.slice(0, idx)}${char}${value.slice(idx + 1)}`;

export const filterPattern = (pattern) => {
	const patternRe = typeof pattern === 'string' ? new RegExp(pattern, 'g') : pattern;
	return (string) => string && string.match(patternRe).join('');
};

export function removeDiacritics(text) {
	return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

/**
 * Truncates the text to a maximum length if it exceeds the limit by more than 2 characters.
 * In that case, it appends an ellipsis ("...") to the end.
 *
 * Why maxLength + 2:
 * If the text is only 1–2 characters longer than maxLength, we keep it as is,
 * because adding "..." would make the result even longer than the original.
 * For example, a string with 72 characters is still shorter than 70 + "..." (which is 73),
 * so it makes sense to only truncate if the original length exceeds maxLength + 2.
 *
 * @param {string} text - The text to potentially truncate.
 * @param {number} maxLength - The maximum number of characters before adding the ellipsis.
 * @param {string} [ellipsis='...'] - The string to append if truncation happens.
 * @returns {string} - The original or truncated string with an ellipsis.
 */
export function truncateWithEllipsis(text, maxLength, ellipsis = '...') {
	const totalAllowedLength = maxLength + ellipsis.length - 1;
	if (text.length > totalAllowedLength) {
		return text.slice(0, maxLength) + ellipsis;
	}
	return text;
}
